import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.benutzer-trouble-tickets-sichtbarkeit-admin';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerTroubleTicketsSichtbarkeitAdminEffects {

    BenutzerTroubleTicketsSichtbarkeitAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BENUTZER_TROUBLE_TICKETS_SICHTBARKEIT_ADMIN),
        mergeMap((x: ac.PostBenutzerTroubleTicketsSichtbarkeitAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBenutzerTroubleTicketsSichtbarkeitAdmin(x.benutzerSichtbarkeitRequest).pipe(
                map((result: any) => {
                    return new ac.PostBenutzerTroubleTicketsSichtbarkeitAdminErfolgreichAction(result, x.benutzerSichtbarkeitRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBenutzerTroubleTicketsSichtbarkeitAdminFehlerAction(error, x.benutzerSichtbarkeitRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerEinstellungenAdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerEinstellungenAdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerEinstellungenAdminCommandService);
        }
        return this.service;
    }
}
